import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { RequestTypeSelect } from "components/UI/RequestTypeSelect";
import { ContainerTrackingCheckboxGroupData } from "constants/checkboxGroupData.constants";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const ContainerTrackingAccess = () => {
  return (
    <>
      <div className={styles.wrapperInputs}>
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many shipments do you need to track per month?"
          fieldName={INPUT_FIELD_NAMES.containerTrackingmonthly_shipments}
          className={styles.perDay}
        />
        <FormFieldControlled
          rules={VALIDATION_SCHEMA.toolInfo.required}
          labelTitle="How many licenses (subaccounts) do you need?"
          fieldName={INPUT_FIELD_NAMES.containerTrackingLicences}
          className={styles.license_count}
        />
      </div>
      <RequestTypeSelect
        rules={VALIDATION_SCHEMA.toolInfo.oneValue}
        fieldName={INPUT_FIELD_NAMES.containerTrackingrequest_types}
        label="Which shipment ID will you use?"
        placeholder="Select request type"
        options={ContainerTrackingCheckboxGroupData}
        className={styles.requestTypeSelect}
      />
    </>
  );
};
